import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function Support() {
  const navigate = useNavigate();

  // ================= FORM STATE =================
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email || !formData.message) {
    Swal.fire({
      icon: "warning",
      title: "All fields are required",
      text: "Please fill all fields before submitting.",
      confirmButtonColor: "#facc15",
    });
    return;
  }

  try {
    const res = await axios.post(
      "https://thegameio.ng/api/contact",
      formData
    );

    if (res.data?.success) {
      Swal.fire({
        icon: "success",
        title: "Message Sent!",
        text: "✅ Your message has been sent successfully.",
        confirmButtonColor: "#facc15",
      });

      setFormData({ name: "", email: "", message: "" });
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed!",
        text: "❌ Failed to send message. Please try again.",
        confirmButtonColor: "#facc15",
      });
    }
  } catch (error) {
    console.error("Support API error:", error?.response?.data || error.message);

    Swal.fire({
      icon: "error",
      title: "Server Error",
      text: "❌ Something went wrong. Please try again later.",
      confirmButtonColor: "#facc15",
    });
  }
};

  // ================= LOGIN STATUS =================
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";

  // ================= GAME CLICK HANDLER =================
  const handleGameClick = (game) => {
    if (!isLoggedIn) {
      navigate("/games");
      return;
    }

    if (game?.link) {
      window.location.href = game.link;
    } else {
      navigate("/games");
    }
  };

  return (
    <div className="bg-black min-h-screen overflow-x-hidden pb-16">

    {/* ================= BANNER ================= */}
<section
  className="relative h-[180px] sm:h-[220px] md:h-[310px] w-full bg-cover bg-center"
  style={{ backgroundImage: "url('/assets/banner-about-bg.webp')" }}
>
  {/* overlay */}
  <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-transparent to-transparent z-10" />

  <div className="relative z-30 h-full flex items-center">
    <div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 lg:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-6">

        {/* LEFT CONTENT */}
        <div className="text-white text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-6 md:mt-10">
            Support
          </h2>

          <div className="flex justify-center md:justify-start gap-2 text-sm text-gray-300 mt-2">
            <span>Home</span>
            <span>›</span>
            <span>Pages</span>
            <span>›</span>
            <span className="text-yellow-400 font-semibold">
              Support
            </span>
          </div>
        </div>

{/* RIGHT IMAGES */}
<div className="relative hidden md:flex justify-end">

  <img
    src="/assets/gamescard/support.png"
    alt="support"
    className="
      w-[420px] md:w-[520px] lg:w-[620px] 
      drop-shadow-2xl translate-y-[28px]
    "
  />

</div>



      </div>
    </div>
  </div>
</section>


      {/* ================= SUPPORT FORM ================= */}
      <section className="py-20 px-4 mb-24">
        <div className="max-w-[1200px] mx-auto flex justify-center">
          
          {/* col-8 centered */}
          <div className="w-full md:w-8/12 lg:w-8/12">
            <div className="rounded-2xl bg-[#20202a] p-6 sm:p-8 shadow-2xl">

              {/* Heading */}
              <h2 className="text-center text-xl sm:text-2xl font-semibold text-white mb-6">
                Have a question or remark? Just send us a message — our team is ready to assist you anytime.
              </h2>

              <form className="space-y-4" onSubmit={handleSubmit}>

                {/* Name */}
                <div>
                  <label className="block mb-1 text-sm text-gray-300">
                    Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full rounded-md bg-[#2a2a3a] px-4 py-2.5
                    text-white placeholder-gray-400 focus:outline-none
                    focus:ring-2 focus:ring-yellow-400"
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="block mb-1 text-sm text-gray-300">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full rounded-md bg-[#2a2a3a] px-4 py-2.5
                    text-white placeholder-gray-400 focus:outline-none
                    focus:ring-2 focus:ring-yellow-400"
                  />
                </div>

                {/* Message */}
                <div>
                  <label className="block mb-1 text-sm text-gray-300">
                    Message
                  </label>
                  <textarea
                    rows="4"
                    name="message"
                    placeholder="Write your message here..."
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full rounded-md bg-[#2a2a3a] px-4 py-2.5
                    text-white placeholder-gray-400 focus:outline-none
                    focus:ring-2 focus:ring-yellow-400 resize-none"
                  />
                </div>

                {/* Button */}
                <button
                  type="submit"
                  className="btn-hover w-full mt-4 rounded-md bg-yellow-400 py-2.5
                  text-black font-semibold transition hover:bg-yellow-500"
                >
                  <span>Submit</span>
                </button>

              </form>
            </div>
          </div>

        </div>
      </section>

      {/* ================= BUTTON HOVER CSS ================= */}
      <style>{`
        .btn-hover {
          position: relative;
          overflow: hidden;
        }
        .btn-hover::before,
        .btn-hover::after {
          content: "";
          position: absolute;
          left: 0;
          width: 100%;
          height: 50%;
          background: #249f22;
          transform: scaleX(0);
          transition: transform 0.35s ease;
          z-index: 0;
          pointer-events: none;
        }
        .btn-hover::before {
          top: 0;
          transform-origin: left;
        }
        .btn-hover::after {
          bottom: 0;
          transform-origin: right;
        }
        .btn-hover:hover::before,
        .btn-hover:hover::after {
          transform: scaleX(1);
        }
        .btn-hover span {
          position: relative;
          z-index: 1;
        }
      `}</style>
    </div>
  );
}

export default Support;
